// Libraries
import {
  NgModule,
  ModuleWithProviders,
  InjectionToken
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Positioning } from 'positioning';

// Components
import { ConfirmationPopoverWindowComponent } from './confirmation-popover-window.component';

// Directives
import { ConfirmationPopoverDirective } from './confirmation-popover.directive';
import { FocusDirective } from './focus.directive';

// Options
import {
  ConfirmationPopoverOptions,
  IConfirmationPopoverOptionsInterface
} from './confirmation-popover-options.provider';

// User options
export const USER_OPTIONS: InjectionToken<string> = new InjectionToken('confirmation popover user options');
// Options factory
export function optionsFactory(userOptions: ConfirmationPopoverOptions): ConfirmationPopoverOptions {
  const options: ConfirmationPopoverOptions = new ConfirmationPopoverOptions();
  Object.assign(options, userOptions);
  return options;
}

@NgModule({
  declarations: [
    ConfirmationPopoverWindowComponent,
    ConfirmationPopoverDirective,
    FocusDirective
  ],
  entryComponents: [
    ConfirmationPopoverWindowComponent
  ],
  exports: [
    ConfirmationPopoverDirective,
    FocusDirective
  ],
  imports: [
    CommonModule
  ]
})
export class ConfirmationPopoverModule {
  public static forRoot(options: IConfirmationPopoverOptionsInterface = {}): ModuleWithProviders {
    return {
      ngModule: ConfirmationPopoverModule,
      providers: [{
        provide: USER_OPTIONS,
        useValue: options
      }, {
        deps: [
          USER_OPTIONS
        ],
        provide: ConfirmationPopoverOptions,
        useFactory: optionsFactory,
      }, Positioning]
    };
  }
}
